import { gql } from '@apollo/client';
import {
  IUserMetrics,
  ProjectSlimForHomeCard,
} from 'spw-redux/modules/home/types';
import { ProjectType } from 'spw-redux/modules/projects/types';
import { BenchmarkReport } from 'spw-redux/modules/benchmark-reports/types';
import { graphqlClient } from './utils';

export const getUserMetrics = () =>
  graphqlClient.query<{ userMetrics: IUserMetrics }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetUserMetrics {
        userMetrics: getMemberMetrics {
          projects {
            joined
            pending
            all
          }
          teams {
            joined
            pending
          }
          reports {
            unverified
            total
          }
        }
      }
    `,
  });

export const getUserFavoriteProjects = (type: ProjectType) =>
  graphqlClient.query<{ projects: ProjectSlimForHomeCard[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetUserFavoriteProjects($type: String) {
        projects: getUserFavoriteProjectsAsProjects(type: $type) {
          id
          insertedAt
          city
          state
          countryCode
          projectName
          projectNumber
          status
          type
          hasMissingBenchmarkData
          buildings {
            id
            city
            state
            countryCode
            streetAddress
            squareFeet
          }
          client {
            id
            name
          }
          createdByUser {
            id
            name
            email
          }
          projectOwner {
            id
            name
            email
          }
          teams {
            id
            hasLogo
            thumbnailS3Path
            name
          }
        }
      }
    `,
    variables: {
      type,
    },
  });

export const getUserFavoriteBenchmarkReportsApi = () => {
  return graphqlClient.query<{
    favoriteReports: BenchmarkReport[];
  }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query UserFavoriteBenchmarkReports {
        favoriteReports: userFavoriteBenchmarkReports {
          id
          name
          approved
          verified
          isMarkedAsFavoriteByUser
          linkedProjectsCount
          industries
          owner {
            id
            name
          }
          lastVerifiedAt
          lastEditor {
            id
            name
            isSuperAdmin
          }
          verifier {
            id
            name
          }
          insertedAt
          updatedAt
        }
      }
    `,
  });
};
